<template>
  <div >
    <!-- Begin Page Content -->
    <div class="container-fluid">

      <!-- Page Heading -->
      <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 class="h3 mb-0 text-gray-800">Inicio</h1>

      </div>
      <!-- Content Row -->
      <div class="row">

        <!-- Content Column -->
        <div class="col-lg-12 mb-4">
          <!-- Color System -->
          <div class="row">
            <div class="col-lg-6 mb-4">
              <div class="card card-collapsable">
                  <a class="card-header bg-primary text-white shadow h5 mb-0 font-weight-bold" href="#collapseCardExample" data-toggle="collapse" role="button" aria-expanded="true" aria-controls="collapseCardExample">Ventas
                  </a>
                  <div class="collapse" id="collapseCardExample">
                      <div class="card-body">
                        <div class="form-row mb-2">
                        <div class="btn-group col">
                            <button type="button" class="btn btn-info dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              Plastificado
                            </button>
                            <div class="dropdown-menu">
                              <a class="dropdown-item" href="plastificado_altobrillo.html">Alto Brillo</a>
                              <a class="dropdown-item" href="plastificado_holografico.html">Holográfico</a>
                              <a class="dropdown-item" href="plastificado_mate.html">Mate</a>
                              <a class="dropdown-item" href="plastificado_normal.html">Normal</a>
                              <a class="dropdown-item" href="plastificado_softtouch.html">Soft Touch</a>
                            </div>
                        </div>
                          <div class="btn-group col">
                            <a  class="btn btn-info" href="barniz.html">
                              Barniz
                            </a>
                          </div>
                        </div>
                        <div class="form-row mb-2">
                        <div class="btn-group col">
                            <button type="button" class="btn btn-info dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              Sectorizado
                            </button>
                            <div class="dropdown-menu">
                              <a class="dropdown-item" href="sectorizado_pleno.html">Sectorizado Pleno</a>
                              <a class="dropdown-item" href="sectorizado_texturizado.html">Texturizado</a>
                              <a class="dropdown-item" href="sectorizado_cintillante.html">Cintillante</a>
                            </div>
                        </div>
                        <div class="btn-group col">
                            <button type="button" class="btn btn-info dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              Insumos
                            </button>
                            <div class="dropdown-menu">
                              <a class="dropdown-item" href="insumos_plastico.html">Plástico</a>
                              <a class="dropdown-item" href="insumos_barniz.html">Barniz</a>
                            </div>
                        </div>
                        </div>
                      </div>
                  </div>
              </div>

            </div>
            <div class="col-lg-6 mb-4">
              <div class="card bg-success text-white shadow h5 mb-0 font-weight-bold">
                <div class="card-body">
                  <a class="text-white" href="cuentas_por_cobrar.html">Cuentas por cobrar</a>
                </div>
              </div>
            </div>
            <div class="col-lg-6 mb-4">
              <div class="card bg-info text-white shadow h5 mb-0 font-weight-bold">
                <div class="card-body">
                  <a class="text-white" href="caja_chica.html">Caja chica</a>
                </div>
              </div>
            </div>
            <div class="col-lg-6 mb-4">
              <div class="card bg-warning text-white shadow h5 mb-0 font-weight-bold">
                <div class="card-body">
                  <a class="text-white" href="administracion.html">Administración</a>
                </div>
              </div>
            </div>
           <div class="col-lg-6 mb-4">
              <div class="card card-collapsable">
                  <a class="card-header bg-danger text-white shadow h5 mb-0 font-weight-bold" href="#collapseCardExample1" data-toggle="collapse" role="button" aria-expanded="true" aria-controls="collapseCardExample1">Reportes
                  </a>
                  <div class="collapse" id="collapseCardExample1">
                      <div class="card-body">
                        <div class="form-row mb-2">
                        <div class="btn-group col">
                            <a  class="btn btn-info" href="reportes_ventas.html">Ventas</a>
                        </div>
                        <div class="btn-group col">
                            <a  class="btn btn-info" href="#">Cuentas por cobrar</a>
                        </div>
                        </div>
                        <div class="form-row mb-2">
                        <div class="btn-group col">
                            <a  class="btn btn-info" href="#">Caja Chica</a>
                        </div>

                        <div class="btn-group col">
                            <a  class="btn btn-info" href="#">Administración</a>
                        </div>
                        </div>
                        <div class="form-row mb-2">
                        <div class="btn-group col">
                            <a  class="btn btn-info" href="#">Estado de Resultado</a>
                        </div>
                        <div class="btn-group col">
                            <a  class="btn btn-info" href="#">Estado de Resultado Consolidado</a>
                        </div>
                        </div>
                      </div>
                  </div>
              </div>

            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  created () {
      this.$store.commit('SET_LAYOUT', 'principal-layout')
  }
}
</script>
